import styled from 'styled-components';
import {Button} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export const StyledModalBtn = styled(Button)`
  margin: 20px 0 !important;
  width: 162px;
  height: 50px;
  line-height: 36px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) !important;
  border-radius: 8px !important;
  border-width: 0 !important;
`
export const ModalBody = styled(Modal.Body)`
  padding: 64px 33px 0 33px ;
  margin-bottom: 40px;
  text-align: center;
`;
export const ModalClose = styled(Button)`
  position: absolute;
  top: -14px;
  right: -12px;
  padding: 10px;
  background: #fff;
  border-radius: 100%;
  border-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  &:hover{
    box-shadow: none;
    border-radius: 100%;
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 100%;
  }
`

export const ModalFooter = styled(Modal.Footer)`
  justify-content: center;
`

export const CloseImg = styled.img`
  width: 100%;
  &.rotate{
    transform: rotate(40deg);
  }
`;
export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
`;

export const StyledSpan = styled.span`
  font-family: NunitoSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 156%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #4F5388;
  margin-left: 15px;
`;
